import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AgencyWaRoutes = defineRoute({
    home: {
        route: {
            path: "/agency-wa",
            component: () => loadView(import("./AgencyWaHome.vue")),
        },
    },
});
